import { UploadedFile } from '@paragon/component-processor';
import { addSpinnerMessage, removeSpinnerMessage } from '@paragon/task-spinner';

import { sequencePlates } from '../data/convertCompareCount';
import { prepareFileDataForUpload } from './files';
import { AsyncThunkActionVoid } from './thunkActions';

export const sequencePlatesFromFiles =
  (fileData: readonly UploadedFile[]): AsyncThunkActionVoid =>
  async (dispatch) => {
    const spinnerId = dispatch(addSpinnerMessage('Sequencing Plates...'));

    try {
      const transformedFileData = await prepareFileDataForUpload(fileData);

      const updatedResults = await sequencePlates(transformedFileData);
      await updatedResults.downloadWithName(`${fileData.map((file) => file.filename).join('.')}.plateSequence`);
    } catch {
      alert('Error sequencing plates.');
    } finally {
      dispatch(removeSpinnerMessage(spinnerId));
    }
  };
